import { ApplicationEnum } from "../types";
import { platformAuthContextFactory } from "../Platform";
import { walletAuthContextFactory } from "../Wallet";
import { seamlessAuthContextFactory } from "../Seamless";
const AuthContextMap = {
    [ApplicationEnum.Platform]: (config) => platformAuthContextFactory(config),
    [ApplicationEnum.Seamless]: (config) => seamlessAuthContextFactory(config),
    [ApplicationEnum.Wallet]: (config) => walletAuthContextFactory(config)
};
export const getAuthContext = (config) => AuthContextMap[config.applicationType](config);
//# sourceMappingURL=getAutContext.js.map